import type { UploadQueueListProps } from "./types";

export function UploadQueueList({ rows, onRemove, onRetry }: UploadQueueListProps) {
    if (rows.length === 0) return null;

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 12 }}>
            {rows.map(row => (
                <div
                    key={row.id}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        border: "1px solid var(--divider, rgba(0, 0, 0, 0.07))",
                        borderRadius: 10,
                        padding: "8px 10px",
                        background: "var(--bg-paper, #ffffff)"
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span
                            style={{
                                flex: 1,
                                minWidth: 0,
                                fontSize: 12.5,
                                fontWeight: 600,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {row.name}
                        </span>
                        {row.stage === "queued" && (
                            <button
                                type="button"
                                onClick={() => onRemove(row.id)}
                                aria-label={`Remove ${row.name} from upload queue`}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "var(--fg4, #6b7280)",
                                    cursor: "pointer",
                                    fontSize: 11.5,
                                    fontWeight: 600
                                }}
                            >
                                Remove
                            </button>
                        )}
                        {row.stage === "error" && (
                            <button
                                type="button"
                                onClick={() => onRetry(row.id)}
                                aria-label={`Retry ${row.name}`}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "var(--np-brand, #2733C2)",
                                    cursor: "pointer",
                                    fontSize: 11.5,
                                    fontWeight: 600
                                }}
                            >
                                Retry
                            </button>
                        )}
                    </div>
                    <div style={{ fontSize: 11.5, color: row.stage === "error" ? "#b91c1c" : "var(--fg4, #6b7280)" }}>
                        {row.stage === "queued" && "Queued"}
                        {row.stage === "uploading" && `Uploading - ${row.progress}%`}
                        {row.stage === "extracting" && `Processing - ${row.progress}%`}
                        {row.stage === "indexed" && "Indexed"}
                        {row.stage === "error" && (row.error ?? "Upload failed")}
                    </div>
                    {row.stage !== "queued" && row.stage !== "error" && (
                        <div
                            style={{
                                height: 6,
                                borderRadius: 999,
                                background: "rgba(15,23,42,0.10)",
                                overflow: "hidden"
                            }}
                        >
                            <div
                                style={{
                                    height: "100%",
                                    width: `${row.progress}%`,
                                    background: "var(--np-brand, #2733C2)",
                                    transition: "width 180ms ease"
                                }}
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
